import { Injectable } from '@angular/core';
import { UrlBuilderService } from '@common/services/url-builder.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { mapTo } from 'rxjs';
import { InvoiceUpload } from '@invoice-upload/models/invoice-upload';
import { Account } from '@feature/invoice-upload/models/account';
import { DocumentType } from '@invoice-upload/models/document-type-code';
import { SaveInvoiceUploadWidgetConfigurationRequest, InvoiceUploadWidgetConfigurationModel } from
  '@invoice-upload/models/save-invoice-upload-widget-configuration-request';
import {GroupedNameValuePairs, NameValueDto} from "@common/models/name-value";


@Injectable({
  providedIn: 'root'
})
export class InvoiceUploadHttpService {

  constructor(
    private readonly urlProvider: UrlBuilderService,
    private readonly http: HttpClient
  ) {}

  getInvoiceDocument(invoiceId: string): Observable<Blob> {
    const url = this.urlProvider.getUrl(`invoice/file/${invoiceId}`);
    const blob = this.http.get(url, { responseType: 'blob' });
    return blob;
  }

  getInvoices(widgetConfigurationId: number): Observable<InvoiceUpload[]> {
    return this.http.get<InvoiceUpload[]>(this.urlProvider.getUrl(`invoices/${widgetConfigurationId}`));
  }

  uploadInvoice(files: any[], widgetConfigurationId: number): Observable<any> {

    const body = new FormData();
    for (let i = 0; i < files.length; i++) {
      body.append('files', files[i]);
    }
    return this.http.post(this.urlProvider.getUrl(`invoice/upload/${widgetConfigurationId}`), body);
  }

  deleteInvoice(id: string): Observable<boolean> {
    return this.http.delete(this.urlProvider.getUrl(`invoice/${id}`)).pipe(mapTo(true));
  }

  getDocumentTypes(): Observable<DocumentType[]> {
    const url = this.urlProvider.getUrl('transactiontypes');
    return this.http.get<DocumentType[]>(url);
  }

  createCopyOfInvoiceUploadConfiguration(config: SaveInvoiceUploadWidgetConfigurationRequest): Observable<boolean> {
    const url = this.urlProvider.getUrl('invoice/config/copy');
    return this.http.post(url, config).pipe(mapTo(true));
  }

  saveInvoiceUploadConfiguration(config: SaveInvoiceUploadWidgetConfigurationRequest): Observable<boolean> {
    const url = this.urlProvider.getUrl('invoice/config');
    return this.http.post(url, config).pipe(mapTo(true));
  }

  getInvoiceUploadConfiguration(widgetConfigId: number): Observable<InvoiceUploadWidgetConfigurationModel> {
    const url = this.urlProvider.getUrl(`invoice/config/${widgetConfigId}`);
    return this.http.get<InvoiceUploadWidgetConfigurationModel>(url);
  }

  getPurchaseOrdersAndContractsForSupplierCreditor(supplierCreditorUri: number): Observable<GroupedNameValuePairs[]> {
    const url = this.urlProvider.getMojoApiUrl(`works/lookups/purchaseOrdersAndContractsForSupplierCreditor/${supplierCreditorUri}`)
    return this.http.get<GroupedNameValuePairs[]>(url)
  }
}
